// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .profile-image {
  width: 80px;
  height: 80px;
  border: 1px solid var(--ion-color-primary);
  background-color: white;
  margin-top: 8px;
  margin-bottom: 8px;
  overflow: hidden;
}
:host ion-card .ion-padding-horizontal {
  padding-left: 20px;
  padding-right: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ax-project-intro/ax-project-intro.component.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,mBAAA;AADJ","sourcesContent":[":host {\n  .profile-image {\n    width: 80px;\n    height: 80px;\n    border: 1px solid var(--ion-color-primary);\n    background-color: white;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    overflow: hidden;\n  }\n\n  ion-card .ion-padding-horizontal {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
